import { TextMenu } from "common/components";
import { ArrowDownIcon, IconWrapper } from "common/components/icon";
import { colors } from "common/const/colors";
import { largeComponentHeight } from "common/const/const";
import { forwardRef } from "react";
import styled from "styled-components";

const DropdownContainer = styled.div`
  position: relative;
  width: 100%;
`;

const DropdownButtonInner = styled.div`
  display: inline-flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: ${largeComponentHeight};
  padding: 0 1.25rem;
  box-sizing: border-box;
  cursor: pointer;

  outline: none;
  background-color: var(--White);
  border: var(--border-width) solid;
  border-radius: var(--border-radius-8);
  border-color: ${({ $error }) => ($error ? colors.Red : colors.Gray)};
`;

export const DropdownButton = forwardRef(function DropdownButton(
  { component, text, placeholder, onClick, isListOpen, error, disabled, children },
  ref,
) {
  return (
    <DropdownContainer>
      <DropdownButtonInner
        ref={ref}
        // react-hook-form의 shouldFocusError가 focus할 수 있도록 포커스 가능하게 함
        tabIndex={disabled ? -1 : 0}
        onClick={!disabled ? onClick : undefined}
        $error={error}
        style={{
          backgroundColor: disabled ? colors.LightGray : "white",
          cursor: disabled ? "not-allowed" : "pointer",
        }}>
        {component || (
          <TextMenu color={!text ? colors.LightNavy : undefined}>
            {text || placeholder}
          </TextMenu>
        )}
        <ArrowDownIcon
          style={{
            transform: isListOpen ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform 0.3s ease",
            opacity: disabled ? 0.5 : 1,
          }}
        />
      </DropdownButtonInner>
      {children}
    </DropdownContainer>
  );
});

export const DropdownList = styled.ul`
  position: absolute;
  top: 100%;
  left: 0;
  margin: 0;
  padding: 0;

  width: 100%;
  box-sizing: border-box;

  max-height: calc(3.5rem * 5);
  overflow-y: auto;

  background-color: var(--White);
  border: 1px solid var(--Gray);
  border-radius: 0.5rem;
  list-style: none;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.2);
  z-index: 10;
`;

const DropdownItemWrapper = styled.li`
  display: flex;
  flex-direction: row;
  padding: 1.25rem;
  justify-content: start;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;

  &:hover {
    background-color: ${({ $selected }) =>
      $selected ? "var(--LightBlue)" : "var(--LightGray)"};
  }

  & + & {
    border-top: 1px solid var(--Gray);
  }
`;

export const DropdownItem = ({ item, onClick, selected }) => {
  return (
    <DropdownItemWrapper onClick={onClick} $selected={selected}>
      {item.component || (
        <>
          {item.icon && (
            // 바깥 박스는 고정 크기(정렬 유지) → 아이콘만 iconSize로 스케일
            <IconWrapper size={"1.5rem"}>
              <IconWrapper size={item.iconSize ?? "1.5rem"}>
                {item.icon}
              </IconWrapper>
            </IconWrapper>
          )}
          <TextMenu>{item.text}</TextMenu>
        </>
      )}
    </DropdownItemWrapper>
  );
};
